import { useCallback, useState } from 'react';
import './dashboardNavItem.scss';
import { Select } from '../../../components/ui/Input';
import useIsAdmin from '../../../hooks/useIsAdmin';
import { icons } from '../../../assets';
import Button from '../../../components/ui/Button';


const DashboardNavItem = ({ navItems, tab, setTab, isSecondTier, navItemsObj, dontShowWithdraw, filterable = true }: {
  navItems: Array<string>;
  tab: string;
  setTab: (val: string) => void;
  isSecondTier?: boolean;
  navItemsObj?: Array<Record<string, any>>;
  dontShowWithdraw?: boolean;
  filterable?: boolean
}) => {
  const [showDropDown, setShowDropDown] = useState(false);
  const isAdmin = useIsAdmin();

  const handleClick = useCallback((item) => {
    setTab(item);
    showDropDown && setShowDropDown(false);
  }, [showDropDown, setTab]);

  if (isSecondTier) {
    return (
      <div className='filter-wrapper flex-wrap my-0 !h-fit py-5'>
        {
          !isAdmin && (
            <>
              {/* <input type="" className='h-10 border border-gray-300 w-96 px-4 my-4' placeholder='Search' /> */}
              {
                filterable && (
                  <div className='flex flex-row w-auto justify-around items-center my-0'>
                    <div className='flex flex-row justify-between items-center w-auto'>
                      <label htmlFor="" className='mr-4 w-[100px]'>Filter by:</label>
                      <Select
                        name="filter"
                        label=''
                        data={navItems}
                        onChange={(field, value) => {
                          setTab(value);
                        }}
                        value={tab}
                        selectClassName='!bg-gray-300'
                      />
                    </div>
                  </div>
                )
              }

            </>
          )
        }

      </div>
    )
  }
  if (navItemsObj) {
    return (
      <div className="!w-fit min-h-10 flex flex-row flex-wrap gap-y-2 ">
        {
          navItemsObj.map((itm, index) => {
            if (itm.renderer) {
              return itm.renderer();
            }
            return (
              <Button
                key={`${index}-${itm.label}`}
                disabled={itm.disabled || itm.loading}
                isLoading={itm.loading}
                className={
                  `text-white w-fit px-4 ml-4 !flex flex-row flex-nowrap items-center h-10 capitalize ${itm.active && !itm.loading ? 'animate-pulse' : ''} ${itm.loading ? 'opacity-70 cursor-wait' : ''}`
                  }
                onClick={itm.action} style={{ background: itm.bgColor }}
                leftIcon={itm.img ? <img src={itm.img} alt="" className='w-5' /> : itm?.icon ? itm?.icon : null}
                rightIcon={itm?.rightIcon && <span className='shrink-0'>{itm.renderItm()}</span>}
              >
                {itm.loading ? `${itm.label}...` : itm.label}
              </Button>
            )
          })
        }
      </div>
    )
  }
  return (
    <ul className="sub-nav dashboard-nav">
      <img
        src={showDropDown ? icons.closeIcon : icons.menu}
        alt="options"
        className="nav-menu"
        onClick={() => setShowDropDown(!showDropDown)}
      />
      {
        navItems.map((item) => (
          <li key={item} className={item === tab ? 'selected' : ''} onClick={() => handleClick(item)}>
            {item}
          </li>
        ))
      }
      {
        showDropDown && (
          <div className='subnav-dropdown'>
            {
              navItems.map((item) => (
                <li key={item} className={item === tab ? 'selected' : ''} onClick={() => handleClick(item)}>
                  {item}...
                </li>
              ))
            }
          </div>
        )
      }
    </ul>
  )
}

export default DashboardNavItem;
